import React, { memo } from "react";
import ProductGrid from "../components/ProductGrid/ProductGrid";
import Layout from "../components/Layout";
import logo from "../assets/images/logo00.webp";
import { fruits } from "../components/HeroSection/floatingItems";
import { code46Products } from "../data/code46Data";

const Code46 = memo(() => {
  return (
    <Layout>
      <div className="w-full h-full flex justify-center items-center relative">
        <div className="relative inline-block">
          <div className="logo-wrapper">
            <img src={logo} alt="Main Logo" className="main-logo" />

            {fruits.map((f) => (
              <img
                key={f.id}
                src={f.src}
                alt={f.alt}
                className="fruit-img"
                style={{
                  top: f.top,
                  left: f.left,
                  width: f.size,
                  zIndex: f.zIndex || 1,
                }}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="max-w-8xl mx-auto px-6 lg:px-12 py-8">
        <ProductGrid products={code46Products} showFilters pageSize={12} />
      </div>
    </Layout>
  );
});

export default Code46;
